<script setup lang="ts">
import { useRuntimeConfig } from '#app';
import type { NuxtLink } from '#components';

defineProps<{
  vertical?: boolean;
}>();

type LinkDestination = NonNullable<InstanceType<typeof NuxtLink>['$props']['to']>;

const links: { label: string; to: LinkDestination; hidden?: boolean }[] = [
  { label: 'Analysis', to: '/analysis' },
  { label: 'Methodology', to: '/methodology' },
  { label: 'Data', to: '/data' },
  { label: 'About', to: '/about' },
  // { label: 'Methane Matters', to: '/why-methane-matters' },
  { label: 'Methane Map', to: '/map', hidden: !useRuntimeConfig().public.features.map },
] as const;
</script>

<template>
  <nav class="nav" :class="{ 'is-vertical': vertical }">
    <template v-for="({ hidden, label, to }) in links" :key="label">
      <NuxtLink v-if="!hidden" class="nav-link body-small" :to>
        {{ label }}
      </NuxtLink>
    </template>
  </nav>
</template>

<style lang="scss" scoped>
@use "@/assets/styles/shared/screen" as screen;

.nav {
  --nav-height: 4.2rem;

  display: flex;
  align-items: center;
  gap: var(--spacing-m);

  &.is-vertical {
    display: block;
  }
}

.nav-link {

  font-weight: 500;
  text-decoration: none !important;

  &.router-link-active {
    color: var(--colour-mid-grey);
    border-bottom: 0.1rem solid var(--colour-mid-grey);
  }

  .nav:not(.is-vertical) & {
    display: flex;
    align-items: center;
    height: var(--nav-height);

    &[href="/map"] {
      padding: 0 2rem;
      border-radius: var(--nav-height);
      border: 0.5px solid var(--colour-dark-grey);
    }
  }

  .nav.is-vertical & {
    display: block;
    font-size: 1.8rem;
    margin: 0;
    padding: 2rem 0;
    border-bottom: 0.1rem solid var(--colour-light-warm-grey);

    &.router-link-active {
      color: var(--colour-accent);
      border-bottom: 0.1rem solid var(--colour-light-warm-grey);
    }
  }
}
</style>
